import { render, staticRenderFns } from "./ButtonIconCard.vue?vue&type=template&id=409a5c1c&scoped=true&"
import script from "./ButtonIconCard.vue?vue&type=script&lang=js&"
export * from "./ButtonIconCard.vue?vue&type=script&lang=js&"
import style0 from "./ButtonIconCard.vue?vue&type=style&index=0&id=409a5c1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409a5c1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VIcon})
